import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@/i18n";
// import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    name: i18n.t("Log in"),
    path: "/login",
    component: () => import("@/views/login/LogIn")
  },
  {
    name: i18n.t("Sign up"),
    path: "/signup",
    component: () => import("@/views/login/SignUp")
  },
  {
    name: i18n.t("Restore password"),
    path: "/restorepassword",
    component: () => import("@/views/login/RestorePassword")
  },
  {
    name: i18n.t("Terms of Service"),
    path: "/tos",
    component: () => import("@/views/login/TermsOfService")
  },
  {
    name: i18n.t("Privacy Policy"),
    path: "/privacypolicy",
    component: () => import("@/views/login/PrivacyPolicy")
  },
  {
    name: i18n.t("Cookie Use"),
    path: "/cookieuse",
    component: () => import("@/views/login/CookieUse")
  },
  {
    name: i18n.t("Print Locations"),
    path: "/printlocations",
    component: () =>
      import("@/views/dashboard/components/locations/PrintLocations")
  },
  {
    path: "/",
    component: () => import("@/views/dashboard/Index"),
    children: [
      // TODO Remove crap
      // Pages

      {
        name: i18n.t("My orders"),
        path: "orders",
        component: () => import("@/views/dashboard/pages/OrdersPage")
      },

      {
        name: i18n.t("My products"),
        path: "products",
        component: () => import("@/views/dashboard/pages/ProductsPage")
      },
      {
        name: i18n.t("My locations"),
        path: "locations",
        component: () => import("@/views/dashboard/pages/LocationsPage")
      },
      {
        name: i18n.t("Settings"),
        path: "/settings",
        component: () => import("@/views/dashboard/pages/SettingsPage")
      },
      { path: "/", redirect: "/orders" }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
